export interface ContextualMessage {
    type: string;
    message: string;
    status?: number;
}

export interface ForgotPasswordNavigationState {
    status: number;
    message: string;
    email: string;
}

export enum LoginPageSectionsEnum {
    Login = 'Login',
    ForgotPassword = 'ForgotPassword',
    CreateNewPassword = 'CreateNewPassword',
    ForceResetEmailSent = 'ForceResetEmailSent',
}
